//--------------------------------------------------------------------------
// <copyright file="webAPIServicePost.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import { v4 as uuidv4 } from 'uuid';

/// <summary>
/// Post service to be used to make post API calls.
/// </summary>
export const webApiServicePost = async (endpoint, token, requestBody, correlationId) => {

  const headers = new Headers();
  const bearer = `Bearer ${token}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");
  headers.append("X-Ms-Correlation-Id", correlationId);
  headers.append("Region", "GEO");

  const options = {
    method: "POST",
    headers: headers,
    body: requestBody
  };

  try {
    const response = await fetch(endpoint, options);
    return response;
  } catch (error) {
    return null;
  }
}